<template>
    <div v-if="showModal"
         class="modal-window-wrapper">
        <Transition name="fade"
                    appear>
            <div v-if="showModal"
                 class="modal-window-overlay"
                 @click="$emit('close')"></div>
        </Transition>
        <Transition name="pop"
                    appear>
            <slot v-if="showModal"
                  class="modal-window" />
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';
export interface Props {
    showModal: boolean

}
const props = withDefaults(defineProps<Props>(), {
    showModal: false,
})
const close = defineEmits(['close']);

const addKeyListener = () => {
    removeKeyListener();
    document.addEventListener('keyup', onKeyListener);
};

const removeKeyListener = () => {
    document.removeEventListener('keyup', onKeyListener);
};

const onKeyListener = (event: KeyboardEvent) => {
    const keys = ['escape', '27'];
    if (event.key) {
        const key = event.key.toLowerCase();

        if (keys.includes(key)) {
            close('close');
            return;
        }
    }
    if (event.code) {
        const code = event.code.toLowerCase();

        if (keys.includes(code)) {
            close('close');
            return;
        }
    }
};

onMounted(() => {
    addKeyListener();
});

onBeforeUnmount(() => {
    removeKeyListener();
});
</script>


<style scoped lang="scss">
.modal-window-wrapper>div {
    z-index: 1050;
    width: 100%;
}

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transform: none;
    z-index: 1050;
}

.modal-window-overlay {
    content: '';
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1040;
    background: var(--dealer-primary-light);
    opacity: 0.6;
    cursor: pointer;
}

.modal-dialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    place-content: center;
    place-items: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
    transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
    opacity: 0;
    transform: scale(0.3) translateY(-40%);
}
</style>
